import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import {
  PictureOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import adminApiService from '../../services/adminApi';

const DashboardPage: React.FC = () => {
  const [stats, setStats] = useState({
    banners: 0,
    products: 0,
    articles: 0,
    materials: 0,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [bannersRes, productsRes, articlesRes, materialsRes] = await Promise.all([
        adminApiService.getData('banners'),
        adminApiService.getData('products'),
        adminApiService.getData('articles'),
        adminApiService.getData('materials'),
      ]);

      setStats({
        banners: bannersRes.data.banners?.length || 0,
        products: productsRes.data.products?.length || 0,
        articles: articlesRes.data.articles?.length || 0,
        materials: materialsRes.data.materials?.length || 0,
      });
    } catch (error) {
      console.error('加载统计数据失败:', error);
    }
  };

  return (
    <div>
      <h2 className="page-header">仪表板</h2>
      <Row gutter={16}>
        <Col span={6}>
          <Card className="stats-card">
            <Statistic
              title="Banner 总数"
              value={stats.banners}
              prefix={<PictureOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stats-card">
            <Statistic
              title="产品总数"
              value={stats.products}
              prefix={<AppstoreOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stats-card">
            <Statistic
              title="文章总数"
              value={stats.articles}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stats-card">
            <Statistic
              title="材料总数"
              value={stats.materials}
              prefix={<ToolOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }} title="快速操作">
        <p>欢迎使用信力凯后台管理系统！</p>
        <p>您可以通过左侧菜单管理以下内容：</p>
        <ul>
          <li><strong>Banner 管理</strong>：管理首页轮播图</li>
          <li><strong>产品管理</strong>：管理产品信息和图片</li>
          <li><strong>文章管理</strong>：管理技术文章和 PDF 文件</li>
          <li><strong>材料管理</strong>：管理材料信息和规格</li>
        </ul>
      </Card>
    </div>
  );
};

export default DashboardPage;
